<template>
  <div class="recent-transactions bg-block shadow-primaryBlock rounded
              px-8 py-8 lg:px-12 lg:py-13 relative">
    <TransactionEditModalProvider :transaction="edit_transaction"
                                  @finished="updateDashboardData"
                                  @close="edit_transaction = null"/>
    <RecentTransactionsHead :account_selected="account_selected"
                            @clearAcc="clearAccount"/>
    <div v-if="loading"></div>
    <div v-else-if="!transactions.length" class="text-center text-lg text-text">
      {{ $t('noTransactions') }}
    </div>
    <template v-else-if="!!transactions.length">
      <div v-for="(transactions,date,i) in transactionsByDate" :key="i">
        <TransactionDate :date="date" :transactions="transactions"/>
        <TransactionItem v-for="(transaction,j) in transactions" :key="j"
                         :transaction="transaction"
                         :layout="layoutType === 'tablet' ? 'compact' : 'default'"
                         @edit="edit_transaction = $event"/>
      </div>
      <div class="mt-10 "
           v-show="current_page < pages_length || more_loading">
                <span v-if="!more_loading"
                      class="text-2sm text-text-ternary cursor-pointer
                      transition duration-200
                      border-b border-dashed border-text-ternary
                      hover:text-red hover:border-red"
                      @click="showMore">{{ $t('showMore') }}</span>
        <font-awesome-icon class="text-primary" v-else icon="circle-notch" spin/>
      </div>
    </template>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import LoaderBlock from '@/components/UI/LoaderBlock.vue';
import RecentTransactionsHead from "@/components/cabinet/Money/Dashboard/RecentTransactions/RecentTransactionsHead";
import TransactionEditModalProvider
  from "@/components/common/Transaction/TransactionEditModal/TransactionEditModalProvider";
import TransactionDate from "@/components/common/Transaction/TransactionDate";
import TransactionItem from "@/components/common/Transaction/TransactionItem/TransactionItem";

export default {
  name: "RecentTransactions",
  components: {
    TransactionItem,
    TransactionDate,
    TransactionEditModalProvider,
    RecentTransactionsHead,
    LoaderBlock,
  },
  data() {
    return {
      more_loading: false,
      edit_transaction: null,
    }
  },
  computed: {
    ...mapState('moneyDashboard/recentTransactions', {
      loading: state => state.transactions.dirty,
      current_page: state => state.transactions.pagination.current_page,
      pages_length: state => state.transactions.pagination.pages
    }),
    ...mapGetters('theme', ['layoutType']),
    ...mapState('moneyDashboard/recentTransactions', ['account_selected']),
    ...mapGetters('moneyDashboard/recentTransactions', ['transactions', 'transactionsByDate'])
  },
  methods: {
    ...mapActions('moneyDashboard/recentTransactions', ['getRecentTransactions', 'loadMoreRecentTransactions']),
    ...mapMutations('moneyDashboard/recentTransactions', ['setPageRecentTransactions', 'setSelectedAcc']),
    clearAccount() {
      this.setSelectedAcc(null)
    },
    showMore() {
      this.setPageRecentTransactions(this.current_page + 1)
    },
    updateDashboardData() {
      this.getRecentTransactions();
      this.$emit('updateDashboard')
    }
  },
  watch: {
    'account_selected': {
      handler: function () {
        this.getRecentTransactions()
      }
    },
    async current_page(newVal) {
      if (newVal === 1) {
        await this.getRecentTransactions()
      } else {
        this.more_loading = true
        await this.loadMoreRecentTransactions()
        this.more_loading = false
      }
    }
  },
  beforeDestroy() {
    this.clearAccount()
  },
  i18n: {
    messages: {
      en: {
        noTransactions: 'No transactions',
        showMore: 'Show more'
      },
      ru: {
        noTransactions: 'Ничего не найдено',
        showMore: 'Показать больше'
      }
    }
  }
}
</script>

<style lang="scss">

.transactions__popover.tooltip.popover {
  .popover-inner {

    padding: 6px 0 4px;
    border: 1px solid #D3D7DC;

    .transactions__popover__btn {
      display: block;
      text-align: left;
      line-height: 24px;
      font-size: 11px;
      color: #555;
      min-width: 40px;
      width: 100%;
      padding-left: 8px;
      padding-right: 10px;
      background: transparent;
      border: 0;
      cursor: pointer;
      transition: all .2s;

      svg {
        width: 10px;
        margin-right: 8px;
      }

      &:hover {
        background: #F3F5F7;
        color: #486680;
      }

      &.--red {
        color: #F2526F;

        &:hover {
          background: rgba(242, 82, 111, .2);
        }
      }
    }
  }

  .popover-arrow {
    display: none;
  }
}
</style>
